import { createAction } from '@reduxjs/toolkit';
import {
  ChatImageDeletedPayload,
  ChatMessageDeletedPayload,
  ChatMessageUploadPreparedPayload,
  ChatReactionToggledPayload,
  PublicChatClearedPayload,
  ChatMessagePayload,
  ToggleChatReactionPayload,
} from 'features/chat/types';

export const clearPublicChatRequested = createAction('chat/clearPublicChatRequested');
export const signalingPublicChatCleared = createAction<PublicChatClearedPayload>(
  'signaling/publicChatCleared'
);

export const deleteChatMessage = createAction<string>('chat/deleteMessage');

export const deleteChatImage = createAction<ChatImageDeletedPayload>('chat/deleteImage');

export const signalingChatMessageSent = createAction<ChatMessagePayload>(
  'signaling/chatMessageSent'
);
export const signalingChatMessageDeleted = createAction<ChatMessageDeletedPayload>(
  'signaling/chatMessageDeleted'
);
export const signalingChatImageDeleted = createAction<ChatImageDeletedPayload>(
  'signaling/chatImageDeleted'
);

export const signalingChatMessageUploadPrepared = createAction<ChatMessageUploadPreparedPayload>(
  'signaling/chat/messageUploadPrepared'
);

export const signalingAllChatMessagesReceived = createAction<{ messages: ChatMessagePayload[] }>(
  'signaling/allChatMessagesReceived'
);

export const toggleChatReaction = createAction<ToggleChatReactionPayload>('chat/toggleReaction');
export const signalingChatReactionToggled = createAction<ChatReactionToggledPayload>(
  'signaling/chatReactionToggled'
);

export const downloadChatImageRequested = createAction<{ url: string; fileName?: string }>(
  'chat/downloadChatImageRequested'
);

export const chatImageUploadFailed = createAction<{ messageId: string }>('chat/imageUploadFailed');
